module.exports = __webpack_public_path__ + "img/binding_pc_tab_01.b260a51d.png";